import type { MetricOutput } from "@/types/api/MetricOutput"

type MetricOutputSource = Pick<MetricOutput, "result_json" | "result">

/**
 * Narrows a metric result payload to a specific interface. Accepts either the
 * raw `result_json` blob (legacy) or a `MetricOutput`-like object that cascades
 * `result_json` first, then `result.raw_values` (typed). Type-only cast -- no
 * runtime validation.
 */
export function parseResultJson<T>(
  input: Record<string, unknown> | MetricOutputSource | null | undefined,
): T | undefined {
  if (input == null) {
    return undefined
  }
  if (isMetricOutputSource(input)) {
    const legacy = input.result_json as T | undefined
    if (legacy != null) {
      return legacy
    }
    const rawValues = input.result?.raw_values as T | undefined
    return rawValues ?? undefined
  }
  return input as T
}

function isMetricOutputSource(
  input: Record<string, unknown> | MetricOutputSource,
): input is MetricOutputSource {
  // MetricOutput always carries both fields (either populated or null);
  // a raw result_json blob carries metric-specific keys instead.
  return "result_json" in input && "result" in input
}
